import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import SignUpModal from 'flarum/forum/components/SignUpModal';
import Stream from 'flarum/common/utils/Stream';

/**
 *  注册、登录页
 */
export default function signContent() {
  extend(SignUpModal.prototype, 'oninit', function () {
    this.doorkey = Stream('RUKO2025');
  });

  extend(SignUpModal.prototype, 'fields', function (fields) {
    const isOptional = app.forum.data.attributes['fof-doorman.allowPublic'];
    const placeholder = isOptional
      ? app.translator.trans('fof-doorman.forum.sign_up.doorman_placeholder_optional')
      : app.translator.trans('fof-doorman.forum.sign_up.doorman_placeholder');

    if (fields.has('doorkey')) {
      fields.remove('doorkey')
    }

    if (!flarum.extensions['fof-doorman']) return;

    fields.add(
      'doorkey',
      <div className="Form-group">
        <input className="FormControl" name="fof-doorkey" type="text" placeholder={placeholder} bidi={this.doorkey} disabled />
      </div>,
      9
    );
  });
}
